import React from 'react';

const styles = {
    container: {
        padding: '12px 16px',
        backgroundColor: '#fafafa',
    },
    grid: {
        display: 'grid',
        gridTemplateColumns: 'minmax(220px, 1fr) minmax(320px, 2fr)',
        gap: '16px',
        alignItems: 'start',
    },
    section: {
        backgroundColor: '#fff',
        border: '1px solid #e0e0e0',
        borderRadius: '4px',
        overflow: 'hidden',
    },
    header: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: '10px 12px',
        borderBottom: '1px solid #e0e0e0',
        backgroundColor: '#f5f7fa',
    },
    titleWrap: {
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
    },
    title: {
        margin: 0,
        fontSize: '14px',
        fontWeight: 600,
        color: '#263238',
    },
    badge: {
        minWidth: '22px',
        padding: '2px 7px',
        borderRadius: '10px',
        backgroundColor: '#e8edf3',
        color: '#37474f',
        fontSize: '12px',
        lineHeight: '16px',
        textAlign: 'center',
        fontWeight: 600,
    },
    dot: {
        width: '10px',
        height: '10px',
        borderRadius: '50%',
        flex: '0 0 auto',
    },
    list: {
        margin: 0,
        padding: 0,
        listStyle: 'none',
    },
    row: {
        display: 'grid',
        gridTemplateColumns: '1fr auto',
        gap: '12px',
        padding: '8px 12px',
        borderBottom: '1px solid #eeeeee',
        alignItems: 'center',
    },
    l0Row: {
        display: 'block',
        padding: '8px 12px',
        borderBottom: '1px solid #eeeeee',
        color: '#37474f',
        fontFamily: 'monospace',
        fontSize: '13px',
    },
    filename: {
        color: '#263238',
        fontFamily: 'monospace',
        fontSize: '13px',
        overflowWrap: 'anywhere',
    },
    date: {
        color: '#607d8b',
        fontSize: '13px',
        whiteSpace: 'nowrap',
    },
    empty: {
        padding: '14px 12px',
        color: '#78909c',
        fontStyle: 'italic',
    },
}


const parseHeaderData = data => {
    if (!data) return {}
    if (typeof data === 'object') return data

    try {
        return JSON.parse(data)
    } catch (e) {
        return {}
    }
}

const getPartialNumber = data => {
    const header = parseHeaderData(data)
    return header.PARTIALNUMBER || header.partialNumber || header.partialnumber || null
}

const extractL0Files = (data) => {
    return data.map(item => {
        const date = new Date(item.time);
        const year = date.getUTCFullYear();
        const month = String(date.getUTCMonth() + 1).padStart(2, '0');
        const day = String(date.getUTCDate()).padStart(2, '0');
        const hours = String(date.getUTCHours()).padStart(2, '0');
        const minutes = String(date.getUTCMinutes()).padStart(2, '0');
        const seconds = String(date.getUTCSeconds()).padStart(2, '0');
        return {
            time: `${year}/${month}/${day} ${hours}:${minutes}:${seconds} UTC`,
            partialNumber: getPartialNumber(item.data),
        };
    });
}

const formatL2Filename = filename => (
    filename ? filename.replace(/_PARQUET\.parquet$/, '') : ''
)

const sortByMetadataDateDesc = (a, b) => (
    new Date(b.metadataDate).getTime() - new Date(a.metadataDate).getTime()
)


const LiveStatusDetail = (props) => {
    const l0Files = extractL0Files(props.data || []);
    const l2Files = [...(props.l2Files || [])].sort(sortByMetadataDateDesc);
    const hasL0Files = l0Files.length > 0;
    const hasL2Files = l2Files.length > 0;

    return (
        <div style={styles.container}>
            <div style={styles.grid}>
                <section style={styles.section}>
                    <div style={styles.header}>
                        <div style={styles.titleWrap}>
                            <span style={{...styles.dot, backgroundColor: hasL0Files ? '#7fcc33' : '#919191'}} />
                            <h3 style={styles.title}>L0 files handled in the last 30 minutes</h3>
                        </div>
                        <span style={styles.badge}>{l0Files.length}</span>
                    </div>
                    {hasL0Files ? (
                        <ul style={styles.list}>
                            {l0Files.map((file, index) => (
                                <li key={index} style={styles.l0Row}>
                                    {file.time}{file.partialNumber ? ` - partial ${file.partialNumber}` : ''}
                                </li>
                            ))}
                        </ul>
                    ) : (
                        <div style={styles.empty}>No L0 files found.</div>
                    )}
                </section>

                <section style={styles.section}>
                    <div style={styles.header}>
                        <div style={styles.titleWrap}>
                            <span style={{...styles.dot, backgroundColor: hasL2Files ? '#7fcc33' : '#919191'}} />
                            <h3 style={styles.title}>L2 files today or yesterday</h3>
                        </div>
                        <span style={styles.badge}>{l2Files.length}</span>
                    </div>
                    {hasL2Files ? (
                        <ul style={styles.list}>
                            {l2Files.map((file, index) => (
                                <li key={`${file.filename}-${index}`} style={styles.row}>
                                    <span style={styles.filename}>{formatL2Filename(file.filename)}</span>
                                    <span style={styles.date}>{file.metadataDate}</span>
                                </li>
                            ))}
                        </ul>
                    ) : (
                        <div style={styles.empty}>No L2 files found.</div>
                    )}
                </section>
            </div>
        </div>
    );
}


export default LiveStatusDetail;
